import { VFrameTrackSliderContext } from './context';

export const useVFrameTrackSliderContext = VFrameTrackSliderContext.hook;
